import React, { useContext, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_SHIP_FROM_ID } from '../../../constants';
import { useInventoryShipFroms } from '../../../hooks/shipFrom';
import { useShipFroms } from '../../../../../hooks/ship-froms/use-ship-froms';
import { stopPropagation } from '../../../helper';

import style from '../style.module.less';

const OrderNumber = ({ fulfillmentPlanId }) => {
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { shipFromId } = {} },
    updateFulfillmentPlan,
    shouldForceShipFrom,
  } = useContext(MarkAsShippedContext);

  const invShipFroms = useInventoryShipFroms();
  const shipFroms = useShipFroms();
  const shipFromsToUse = shouldForceShipFrom ? shipFroms : invShipFroms;

  const selectedShipFrom = useMemo(
    () => shipFromsToUse.find((shipFrom) => shipFrom.shipFromId === shipFromId) || {},
    [shipFromId, shipFromsToUse],
  );

  const renderSingleShipFrom = useCallback(() => {
    return shipFromsToUse[0].name;
  }, [shipFromsToUse]);

  const renderShipFromDropdown = useCallback(() => {
    return (
      <DropdownMenu variant='form'>
        <DropdownMenuToggler className={style['dropdown-toggler']}>{selectedShipFrom.name || 'Select One...'}</DropdownMenuToggler>
        {shipFromsToUse.map((shipFrom) => (
          <DropdownMenuItem
            key={shipFrom.shipFromId}
            onClick={() => updateFulfillmentPlan(fulfillmentPlanId, MARK_AS_SHIPPED_SHIP_FROM_ID, shipFrom.shipFromId)}
          >
            {shipFrom.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    );
  }, [fulfillmentPlanId, selectedShipFrom, shipFromsToUse, updateFulfillmentPlan]);

  return (
    <div onClick={stopPropagation} onScroll={stopPropagation}>
      {shipFromsToUse.length > 1 ? renderShipFromDropdown() : renderSingleShipFrom()}
    </div>
  );
};

OrderNumber.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default OrderNumber;
